module.exports = __webpack_public_path__ + "static/media/23.b6560e8a.jpg";